import React from 'react';
import LockIcon from '@mui/icons-material/Lock'
import { Avatar, Typography, Container, Snackbar } from '@mui/material'
import { withStyles } from 'tss-react/mui';
import { Redirect } from 'react-router-dom';
import { authenticationService } from './services/auth_service';
import { history } from './services/history'
import { userService } from './services/user_functions';

const useStyles = (theme, props) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  text: {
    marginTop: theme.spacing(0.8),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 100,
    color: '#fff',
  },
  grid: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  filtrosHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
})


const GovbrButton = ({ onClick }) => {
  return (
    <button
      type="button"
      className="br-sign-in"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
      }}
    >
      Entrar com&nbsp;
      <img
        src="https://www.gov.br/++theme++padrao_govbr/img/govbr-colorido-b.png"
        alt="gov.br"
        style={{ height: '24px' }}
      />
    </button>
  );
};

const handleClickGov = () => {

  // axios.get(`${apiPath}/login_gov`)
  authenticationService.requestGovLoginURL()
    .then(response =>{
      if (response.status === 200){
        window.location.href = response.data.auth_url
      }
    })
      .catch( error => {
      }
      )

}



class FamilyLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      openClose: false,
      showPassword: false,
      message: "Verifique seu login e senha e tente novamente.",
      accept_terms: false,
      openEdit: false
    }
  }

  updateUsername = (event) => {
    this.setState({ username: event.target.value });
  }
  handleClose = () => {
    this.setState({ openClose: false })
  }
  updatePassword = (event) => {
    this.setState({ password: event.target.value });
  }

  tryLoginSecondTime = () => {
    authenticationService.loginFamilia(this.state.username, this.state.password)
      .then(result => {
        if (result.status === 200) {
          this.setState({ loginOK: true })
        }
        else {
          this.setState({ message: "Houve um erro na conexão com o sistema. Tente novamente mais tarde.", openClose: true })
        }
      }).catch(e => {
        if (e.response) {
        if (e.response.status === 403) 
          {this.setState({ message: "Para utilizar o sistema você precisa ler e concordar com os termos de uso." }) 
           this.setState({ openEdit: true });}
        else if (e.response.status === 401) 
          {this.setState({ message: "Verifique seu login e senha e tente novamente."}) 
           this.setState({ openClose: true });}
        else if (e.response.status >= 500) 
          {this.setState({ message: "Houve um erro na conexão com o sistema. Tente novamente mais tarde.", openClose: true })}
        this.setState({ openClose: true });
      }
      else {
        this.setState({ message: "Houve um erro na conexão com o sistema. Tente novamente mais tarde.", openClose: false })
      }
    })
  }
  updateAcceptTerms = () => {
    userService.updateAcceptTerms(this.state.username) //para familia é usarname
    .then(result => {
      if (result.status === 200) {
        this.setState({ message: "Você aceitou os termos de uso. Entre com login e senha novamente.", openEdit: false })
        this.tryLoginSecondTime()
      }
    }).catch(e => {
      if (e.response) {
        if (e.response.status >= 500) 
        {this.setState({ message: "Houve um erro na conexão com o sistema. Tente novamente mais tarde.", openClose: true })}
      this.setState({ openClose: true });
      }
      else {
        this.setState({ message: "Houve um erro na conexão com o sistema. Tente novamente mais tarde.", openClose: false })
      }
    })
  }
 handleCallBack = (edit, value) => {
    if (edit) {
      this.setState({ openEdit: true })
      this.setState({ row: { ...value } })
    }
  }
  handleShowPassword = () => {
    this.setState({ showPassword: !(this.state.showPassword) })
  }

  render() {
    const { classes } = this.props;
    if (this.props.userData){
      if (this.props.userData.is_superuser)
          history.push("/Admin")
      else if (this.props.userData.is_staff)
          history.push("/Funcionario")
      else history.push("/Familia")
  }
  else
    if (this.state.loginOK) {
      return (<Redirect to={{ pathname: '/Familia' }} />);
    }
  else return (
        <Container component="main" maxWidth="xs" className={classes.paper}>
          <Avatar className={classes.avatar}><LockIcon /></Avatar>
          <Typography align='center' component="h3" variant="h5" >Mãe do bebê, faça login usando sua conta GOV.BR</Typography>
          <br/>
          {/* <Typography align='center' component="h5">
            Acesso somente para coletas realizadas na <b> Maternidade de Campinas</b>, com expansão em breve para os demais locais
          </Typography>
          <br/> */}
            <GovbrButton onClick={handleClickGov} />
          <Snackbar className={classes.alertMessage} open={this.state.openClose} autoHideDuration={3000} onClose={this.handleClose} message={this.state.message} />
          {/* <Typography><a target="_blank" rel="noopener noreferrer" href='https://drive.google.com/drive/folders/1yHodbDxjjT9qU7TLvNnDP33OIyx6QDhV'>
                    Instruções de acesso para famílias<br/><center><VideocamIcon/></center> </a></Typography> */}
        </Container>
    )
  }
}


export default withStyles(FamilyLogin, useStyles);

